"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _reactRouterDom = require("react-router-dom");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _DefaultModal = _interopRequireDefault(require("Modals/DefaultModal.jsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
const UserForm = props => {
  let navigate = (0, _reactRouterDom.useNavigate)();
  const ref = (0, _react.useRef)(null);
  const [userLogin, setUserLogin] = (0, _react.useState)("");
  const [userPassword, setUserPassword] = (0, _react.useState)("");
  const [userFirstname, setUserFirstname] = (0, _react.useState)("");
  const [userName, setUserName] = (0, _react.useState)("");
  const [userActivity, setUserActivity] = (0, _react.useState)("orthodontiste");
  const [userPhone, setUserPhone] = (0, _react.useState)("");
  const [userWorkplace, setUserWorkplace] = (0, _react.useState)("");
  const [userRpps, setUserRpps] = (0, _react.useState)("");
  const [isValid, setIsValid] = (0, _react.useState)();
  const [loading, setLoading] = (0, _react.useState)(props.type === 'update');
  const [status, setStatus] = (0, _react.useState)({});
  const [status_messages, setStatusMessages] = (0, _react.useState)({});
  const [deleteModal, setDeleteModal] = (0, _react.useState)();
  const url_id = document.location.pathname.split((0, _Routing.URL)('AdminUsersDashboard') + '/')[1];
  const userRole = window.app.state.session.user.roles[0];
  const fetchUser = () => {
    setLoading(true);
    (0, _ajaxRequest.default)((0, _Routing.action)('getAllUsers'), {
      data: {
        id: url_id,
        with_count: false
      }
    }).then(function (response) {
      const {
        name,
        login,
        firstname,
        activity,
        phone,
        workplace,
        rpps,
        is_valid
      } = response.data[0];
      setUserName(name);
      setUserLogin(login);
      setUserFirstname(firstname);
      setUserActivity(activity);
      setUserPhone(phone);
      setUserWorkplace(workplace);
      setUserRpps(rpps);
      setIsValid(is_valid);
      setLoading(false);
    }).catch(function (errors) {
      console.log(errors);
      setLoading(false);
    });
  };
  (0, _react.useEffect)(() => {
    if (props.type === "update") {
      fetchUser();
    }
  }, []);
  const loader = loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  const onFormSubmit = async (e, isValidated) => {
    let user = {
      name: userName,
      password: userPassword,
      login: userLogin,
      firstname: userFirstname,
      activity: userActivity,
      phone: userPhone,
      workplace: userWorkplace,
      rpps: userRpps,
      is_valid: typeof isValidated === "undefined" ? isValid : isValidated
    };
    try {
      if (props.type === "update") {
        const userId = document.location.pathname.split((0, _Routing.URL)('AdminUsersDashboard') + "/")[1];
        const response = await (0, _ajaxRequest.default)((0, _Routing.action)('updateUser'), {
          data: {
            user: user,
            id: userId
          }
        });
        const {
          statement,
          error,
          info,
          warning
        } = response;
        setStatus({
          statement,
          error,
          info,
          warning
        });
        window.setTimeout(function () {
          navigate((0, _Routing.URL)('/liste-des-utilisateurs'));
        }, 2000);
      } else {
        const response = await (0, _ajaxRequest.default)((0, _Routing.action)('createNewUser'), {
          data: {
            user: user
          }
        });
        const {
          statement,
          error,
          info,
          warning
        } = response;
        setStatus({
          statement,
          error,
          info,
          warning
        });
        setLoading(true);
        window.setTimeout(function () {
          props.publicPage ? navigate((0, _Routing.URL)('/login')) : navigate((0, _Routing.URL)('/liste-des-utilisateurs'));
        }, 2000);
      }
    } catch (update) {
      const {
        statement,
        error,
        info,
        warning
      } = update;
      setStatus({
        statement,
        error,
        info,
        warning
      });
      setStatusMessages(update.status_messages);
      return setLoading(false);
    }
    setLoading(false);
  };
  const deleteUser = async () => {
    var _ref$current, _ref$current$click;
    const userId = document.location.pathname.split((0, _Routing.URL)('AdminUsersDashboard') + "/")[1];
    var response = await (0, _ajaxRequest.default)((0, _Routing.action)('deleteUser'), {
      data: {
        id: userId
      }
    });
    const {
      statement,
      error,
      info,
      warning
    } = response;
    setStatus({
      statement,
      error,
      info,
      warning
    });
    window.setTimeout(function () {
      navigate((0, _Routing.URL)('/liste-des-utilisateurs'));
    }, 2000);
    setLoading(false);
    setStatus(response);
    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$click = _ref$current.click) === null || _ref$current$click === void 0 ? void 0 : _ref$current$click.call(_ref$current);
  };
  const footer_del_btn = /*#__PURE__*/_react.default.createElement("button", {
    role: "button",
    "aria-label": "Fermer",
    className: 'c-flat-btn c-flat-btn--red u-margin-right-30',
    onClick: deleteUser
  }, "Supprimer d\xE9finitivement");
  const fetch_loader = props.type === 'update' && !userLogin && loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['primary', 'bg-white']
  }) : undefined;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("form", {
    className: props.paper !== false ? 'c-paper' : undefined
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 2,
    className: "user-form"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setUserLogin(e.value),
    value: userLogin,
    name: "user[login]",
    type: "email",
    label: "E-mail (login)",
    autocomplete: "new-email",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setUserPassword(e.value),
    value: userPassword,
    name: "user[password]",
    type: "password",
    label: "Mot de passe",
    autocomplete: "new-password",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setUserFirstname(e.value),
    value: userFirstname,
    name: "user[firstname]",
    type: "text",
    label: "Pr\xE9nom",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setUserName(e.value),
    value: userName,
    name: "user[name]",
    type: "text",
    label: "Nom",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8,
    className: "radio-group"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "radio-group__name"
  }, "Activit\xE9 : "), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    onClick: () => setUserActivity("chirurgien"),
    checked: userActivity === "chirurgien",
    value: "chirurgien",
    color: "primary",
    name: "user[activity]",
    id: "chirurgien"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "dentiste"
  }, "Chirurgien")), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    onClick: () => setUserActivity("orthodontiste"),
    checked: userActivity === "orthodontiste",
    value: "orthodontiste",
    color: "primary",
    name: "user[activity]",
    id: "orthodontiste"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "orthodontiste"
  }, "Orthodontiste")), userRole === "admin" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    onClick: () => setUserActivity("deltex"),
    checked: userActivity === "deltex",
    value: "deltex",
    color: "primary",
    name: "user[activity]",
    id: "deltex"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "deltex"
  }, "deltex")) : undefined), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setUserPhone(e.value),
    value: userPhone,
    name: "user[phone]",
    type: "text",
    label: "T\xE9l\xE9phone",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setUserWorkplace(e.value),
    value: userWorkplace,
    name: "user[workplace]",
    type: "text",
    label: "Lieu d'exercice",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setUserRpps(e.value),
    value: userRpps,
    name: "user[rpps]",
    type: "text",
    label: "Num\xE9ro RPPS",
    status: status_messages
  })), isValid === false ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _bemit.default)('c-flat-btn', ['validate']),
    onClick: e => {
      onFormSubmit(e, true);
      setIsValid(true);
    }
  }, "Valider l'utilisateur", loader)) : isValid === undefined ? undefined : /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 8
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Utilisateur valid\xE9"))), (0, _getFormStatus.default)(status), fetch_loader), /*#__PURE__*/_react.default.createElement("div", {
    className: "u-full-width u-flex u-content-between u-text-center u-margin-top-25 u-padding-bottom-20 "
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _bemit.default)('c-flat-btn', ['primary']),
    onClick: onFormSubmit
  }, props.publicPage ? "S'inscrire" : props.type === 'update' ? 'Mettre à jour' : 'Créer cet utilisateur', loader), props.type === 'update' && url_id !== app.state.session.user.id ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "c-form__delete",
    onClick: e => setDeleteModal({
      open: true,
      src: e === null || e === void 0 ? void 0 : e.target
    })
  }, "Supprimer utilisateur", loader) : undefined, /*#__PURE__*/_react.default.createElement(_DefaultModal.default, {
    open: deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.open,
    onClose: setDeleteModal,
    bemit: ["small"],
    "close-label": "Annuler",
    "action-buttons": footer_del_btn,
    trigger_src: deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.src,
    "close-ref": ref
  }, "La suppression de l'utilisateur est d\xE9finitive et irr\xE9m\xE9diable. Etes vous sur de vouloir continuer ?")));
};
var _default = exports.default = UserForm;
